import API from "@aws-amplify/api";
import {
  createChat,
  createChatMessage,
  updateChat,
  updateChatMessage,
} from "../../../../app/src/graphql/mutations";
import { getChat } from "../../../../app/src/graphql/queries";
const combinedQuery = /* GraphQL */ `
  query GetWorkspaceAndAgent($workspaceId: ID!, $agentId: ID!) {
    getWorkspace(id: $workspaceId) {
      id
      customChartingConfig
    }
    getAgent(id: $agentId) {
      id
      label
      icon
      largeLogo
      messagesOnLaunch
      rotateMessagesOnLaunchInterval
      showSplashWhenEmpty
      placeholderMessageOnLoading
      allowFeedback
      showAgentName
      placeholderInputMessage
      showWidgetControls
      showToolCallsDetailsInWidget
      messageOnLaunch
      mode
      disclaimer
      darkColor
      color
      llmBaseModel
      darkLogoBackground
      logoBackground
      showTimeForResponse
      showDetectedLanguage
      quickQuestions
      forcedTheme
      allowAudiosUpload
      allowImagesUpload
      allowVideosUpload
      allowDocsUpload
      autoVoiceMode
      preventWidgetUsage
      voiceSensitivity
    }
  }
`;
const createChat_ = async (object, authToken) => {
  return API.graphql({
    query: createChat,
    variables: { input: object },
    authMode: "API_KEY",
    authToken,
  });
};
const getChat_ = async (id) => {
  return API.graphql({
    query: getChat,
    variables: { id },
  });
};
const updateChat_ = async (id, args, authToken) => {
  const original = await getChat_(id);
  let _properties = {};
  args.forEach((item) => {
    _properties[item.property] = item.value;
  });
  return API.graphql({
    query: updateChat,
    variables: {
      input: {
        id,
        _version: original?.data?.getChat?._version,
        ..._properties,
      },
    },
    authMode: "API_KEY",
    authToken,
  });
};

const createChatMessage_ = async (object, authToken) => {
  return API.graphql({
    query: createChatMessage,
    variables: { input: object },
    authMode: "API_KEY",
    authToken,
  });
};

const updateChatMessage_ = async (object, authToken) => {
  return API.graphql({
    query: updateChatMessage,
    variables: { input: object },
    authMode: "API_KEY",
    authToken,
  });
};

const getAgent_ = async (agentId, workspaceId, authToken) => {
  return API.graphql({
    query: combinedQuery,
    variables: { workspaceId: workspaceId, agentId: agentId },
    authMode: "API_KEY",
    authToken,
  });
};

export default {
  createChat: createChat_,
  createChatMessage: createChatMessage_,
  updateChatMessage: updateChatMessage_,
  getAgent: getAgent_,
  updateChat: updateChat_,
};
